
export function getMappedValue(value) {
  let code = value;

  switch (value) {
    case 'parkingspace':
      code = 'parking';
      break;
    case 'laundryroom':
      code = 'apartment';
      break;
    case 'outdoor':
      code = 'apartment';
      break;
    case 'storagearea':
      code = 'apartment';
      break
    case 'recyclingroom':
      code = 'apartment';
      break
    case 'strollerroom':
      code = 'apartment';
      break;
    case 'staircase':
      code = 'apartment';
      break;
    case 'basement':
    case 'attic':
      code = 'apartment';
      break;
    case 'rentedstorage':
      code = 'premise';
      break;
    case 'bicyclegarage':
      code = 'apartment';
      break;
    case 'playground':
      code = 'apartment';
      break;
    case 'roof':
      code = 'apartment';
      break;
  }

  return code;
}


export function getMappedContractValue(value) {
  let code = value;

  switch (value) {
    case 'parkingspace':
      code = 'parking';
      break;
    case 'laundryroom':
      code = 'apartment';
      break;
    case 'outdoor':
      code = 'apartment';
      break;
    case 'storagearea':
      code = 'apartment';
      break
    case 'rentedstorage':
      code = 'premises';
      break
    case 'recyclingroom':
      code = 'apartment';
      break
    case 'strollerroom':
      code = 'apartment';
      break;
    case 'staircase':
      code = 'apartment';
      break;
    case 'basement':
    case 'attic':
      code = 'apartment';
      break;
    case 'bicyclegarage':
      code = 'apartment';
      break;
    case 'playground':
      code = 'apartment';
      break;
    case 'roof':
      code = 'apartment';
      break;
    case 'pests':
      code = 'apartment';
      break;
  }

  return code;
}



export function isOutside(value) {
  let isOutSide = false;

  switch (value) {
    case 'outdoor':
      isOutSide = true;
      break;
    case 'storagearea':
      isOutSide = true;
      break
    case 'recyclingroom':
      isOutSide = true;
      break
    case 'strollerroom':
      isOutSide = true;
      break;
    case 'staircase':
      isOutSide = true;
      break;
    case 'basement':
    case 'attic':
      isOutSide = true;
      break;
    case 'bicyclegarage':
      isOutSide = true;
      break;
    case 'laundryroom':
      isOutSide = true;
      break;
    case 'parkingspace':
      isOutSide = true;
      break;
    case 'playground':
      isOutSide = true;
      break;
    case 'roof':
      isOutSide = true;
      break;
    case 'rentedstorage':
      isOutSide = true;
      break;
  }

  return isOutSide;
}
